// src/components/RouteGuards.js
// Provides PrivateRoute, PublicRoute, and OrgAdminRoute wrappers using AuthContext

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export const PrivateRoute = ({ children }) => {
    const { user, userPortalAccess, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Block firm-only users from accessing user portal routes
    if (!userPortalAccess) {
        return <Navigate to="/firm-portal" replace />;
    }

    return children;
};

export const PublicRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (user) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export const OrgAdminRoute = ({ children }) => {
    const { user, isOrgAdmin, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!isOrgAdmin) {
        return <Navigate to="/client-dashboard" replace />;
    }

    return children;
};